module.exports = __webpack_public_path__ + "img/tradingproductIndexCfd.b43188b6.png";